import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import ClipLoader from "react-spinners/ClipLoader";
import Charger from './Charger/Charger';
import { Box, Button, InputAdornment, Menu, MenuItem, Stack, TextField, ToggleButton, ToggleButtonGroup, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import Sidebar from '../Sidebar/Sidebar';
import { useGetAllBrandsQuery, useGetAllColorsQuery, useGetAllActiveChargersQuery, useGetAllStoragesQuery, useGetAllInactiveChargersQuery } from '../../../features/fullApi';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import Error500 from '../../ErrorPages/Error500';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import '../../../App.css'
import '../autocomplete.css'
import PaginationComp from '../Pagination/PaginationComp';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const Container = styled.div`
   margin-top: 20px;
`;

const MobileContainer = styled.div`
  margin-top: 180px;
`;


const Chargers = () => {
  let user = useSelector(state => state.auth.user)
  if(!user) {
    user = JSON.parse(localStorage.getItem('user')) || ""
  }
  window.scrollTo(0, 0);

  useEffect(() => {
    if(!user) {
    }

  }, [user])

  const params = useParams()

  //#################################
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //#################################

  const {data, error, isLoading} = useGetAllActiveChargersQuery();
  const {data: dataInactive, error: errorInactive, isLoading: isLoadingInactive} = useGetAllInactiveChargersQuery();

  const [resetFilter, setResetFilter] = useState(false);
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(params.page - 1)

  //!constructing the brands/storages/colors key value array with id:name
  const {data:brands, errorBrands, isLoadingBrands} = useGetAllBrandsQuery();
  let brandsArr = []
  brands?.map(brand => {
    brandsArr[brand._id] = brand.brandName
  })

  const {data:storages, errorStorages, isLoadingStorages} = useGetAllStoragesQuery();
  let storagesArr = []
  storages?.map(storage => {
    storagesArr[storage._id] = storage.storageName
  })

  const {data:colors, errorColors, isLoadingColors} = useGetAllColorsQuery();
  let colorsArr = []
  colors?.map(color => {
    colorsArr[color._id] = color.colorName
  })
  //!constructing the brands key value array with id:name

  const theme = useTheme()
  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));

  let chargersPerPage

  if(isXs || isSm) {
    chargersPerPage = 16
  } else if(isMd) {
    chargersPerPage = 24
  } else {
    chargersPerPage = 32
  }

  const pagesVisited = pageNumber * chargersPerPage
  const [act, setAct] = useState(true)


  let location = useLocation()
  let concatenate = location.pathname.split(/___(.*)/s)[1]
  if(!concatenate) {
    concatenate = ""
  }
  useEffect(() => {
    navigate(`/chargers/${pageNumber + 1}`)
    sessionStorage.setItem('pageNumber', pageNumber)
    if(filtered) {
      setDisplayChargers(filteredChargers?.slice(pagesVisited, pagesVisited + chargersPerPage))
    } else {
      setDisplayChargers(data?.slice(pagesVisited, pagesVisited + chargersPerPage))
    }
  }, [pageNumber])


  const [displayChargers, setDisplayChargers] =  useState([])
  
  const [pageCount, setPageCount] = useState(0)

  useEffect(() => {
    if(!isLoading && !isLoadingInactive) {
      if(!act) {
        setDisplayChargers(dataInactive?.slice(pagesVisited, pagesVisited + chargersPerPage))
        setPageCount(Math.ceil(dataInactive?.length / chargersPerPage))
      } else {
        setDisplayChargers(data?.slice(pagesVisited, pagesVisited + chargersPerPage))
        setPageCount(Math.ceil(data?.length / chargersPerPage))
      }
    }
  }, [isLoading, isLoadingInactive, act, data, dataInactive])

 

  const [filteredChargers, setFilteredChargers] = useState([])
  const [filtered, setFiltered] = useState(false)

  const [hitted, setHitted] = useState(false)


  const handleFilterChargers = async (filteredChargers) => {
    setFiltered(true)
    setPageCount(Math.ceil(filteredChargers?.length / chargersPerPage))
    setDisplayChargers(filteredChargers?.slice(pagesVisited, pagesVisited + chargersPerPage))
    setFilteredChargers(filteredChargers)
  }

  const clearSearch = () => {
    const resetSearch = async () => {
     setSearch("")
    };
    resetSearch()
  }

  const [showSidebar, setShowSidebar] = useState(false)

  const navigate = useNavigate()

  const handleStatus = (event, newStatus) => {
    if (newStatus !== null) {
      if(newStatus === "Active") {
        setAct(true)
      } else {
        setAct(false)
      }
    }
  };

  const StackSelect = () => (
    <Stack direction="row" style={{display: 'flex', justifyContent: 'center', alignCenter: 'center', marginBottom:'20px'}}>
    <ToggleButtonGroup
      value={act}
      exclusive
      onChange={handleStatus}
      aria-label="text alignment"
    >
      <ToggleButton value="Active">
        <CheckIcon style={{color: 'green'}} />
      </ToggleButton>
      <ToggleButton value="Inactive">
        <CloseIcon style={{color: 'red'}}/>
      </ToggleButton>
    </ToggleButtonGroup>
  </Stack>
  )


  const renderMobileChargers = () => (
    <>
    <div>
      {act ? (
      <div>
        {isLoadingInactive ? (
          <div className="flexCenter" style={{height: 'calc(100vh - 130px)'}}>
            <ClipLoader
              color="#93032E"
              loading={isLoadingInactive}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>      
        ) : errorInactive ? (<Error500></Error500>)
        :(<>
          <MobileContainer>
            <div id={showSidebar ? "sidebarShow" : "hideSidebar"}>{user?._id &&
                <Sidebar type={"charger"} handleFilterChargers={handleFilterChargers} showSidebar={showSidebar} setShowSidebar={setShowSidebar} resetFilter={resetFilter}/>}
            </div>
            <MobileContainer>
            <div style={{position: 'fixed', top: '0', zIndex:"200", marginTop: '110px', padding:'10px 0', backgroundColor:"#fff", display: 'flex', justifyContent: 'space-around', width: '100%'}}>
              <Button style={{width: '150px', fontSize: "12px"}} color="primary" variant="contained" onClick={() => setShowSidebar(true)}>Show filters</Button>
              {user?.isAdmin &&
              (
              <>
                <Button variant="contained" color="secondary" style={{width: '150px', fontSize: "12px"}} onClick={() => navigate("/charger/create")}>Add Charger</Button>
              </>
              )
              }
            </div>
          </MobileContainer>

          </MobileContainer>

            <MobileContainer>
              <h3 style={{textAlign: 'center'}}>Chargers</h3>
              {user?.isAdmin && <StackSelect/> }
              <Grid container rowSpacing={2} columnSpacing={1} className="gridClass">
                {(filteredChargers.length > 0 ) &&
                <>
                  {filteredChargers.filter((charger) => {
                    return search.toLowerCase() === '' ? charger : charger.title.toLowerCase().includes(search)
                  }).map((charger) => (
                    <Grid key={charger._id} item xs={6} lg={4} xl={2}>
                      <Charger charger={charger}/>
                    </Grid>
                  ))}
                </>
                }
                {!hitted &&
                <>
                  {search ? (
                  <>
                    {dataInactive?.map((charger) => (
                        <Grid key={charger._id} item xs={6} lg={3} xl={2}>
                          <Charger charger={charger}/>
                        </Grid>
                      ))}
                  </>
                  ) : (
                    <>
                    {displayChargers?.map((charger) => (
                      <Grid key={charger._id} item xs={6} lg={3} xl={2}>
                        <Charger charger={charger}/>
                      </Grid>
                    ))}
                  </>
                  )
                  }
                  <PaginationComp pageCount={pageCount} pageNumber={pageNumber} setPageNumber={setPageNumber}/>
                </>}
                <div>
                  {(filteredChargers.length === 0 && hitted) && 
                  <h3>
                    No chargers found for your search
                  </h3>}
                </div>
              </Grid>
            </MobileContainer>
          </>
        )
      }
      </div>) : (
              <div>
              {isLoading ? (
                <div className="flexCenter" style={{height: 'calc(100vh - 130px)'}}>
                  <ClipLoader
                    color="#93032E"
                    loading={isLoading}
                    size={150}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                </div>      
              ) : error ? (<Error500></Error500>)
              :(<>
                <MobileContainer>
                  <div id={showSidebar ? "sidebarShow" : "hideSidebar"}>{user?._id &&
                      <Sidebar handleFilterChargers={handleFilterChargers} showSidebar={showSidebar} setShowSidebar={setShowSidebar} resetFilter={resetFilter}/>}
                  </div>
                  <MobileContainer>
                  <div style={{position: 'fixed', top: '0', zIndex:"200", backgroundColor:"#fff", marginTop: '110px', padding:'10px 0', display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                    <Button style={{width: '150px', fontSize: "12px"}} color="primary" variant="contained" onClick={() => setShowSidebar(true)}>Show filters</Button>
                    {user?.isAdmin &&
                    (
                    <Button variant="contained" color="secondary" style={{width: '150px', fontSize: "12px"}} onClick={() => navigate("/charger/create")}>Add Charger</Button>
                    )
                    }
                  </div>
                </MobileContainer>
      
                </MobileContainer>
      
                  <MobileContainer>
                    <h3 style={{textAlign: 'center'}}>Chargers</h3>
                    {user?.isAdmin && <StackSelect/> }
                    <Grid container rowSpacing={2} columnSpacing={1}>
                      {(filteredChargers.length > 0 ) &&
                      <>
                        {filteredChargers.map((charger) => (
                          <Grid key={charger._id} item xs={6} lg={3} xl={2}>
                            <Charger charger={charger}/>
                          </Grid>
                        ))}
                      </>}
                      {!hitted &&
                      <>
                        {search ? (
                        <>
                          {data?.filter((charger) => {
                              return search.toLowerCase() === '' ? charger : charger.title.toLowerCase().includes(search)
                            }).map((charger) => (
                              <Grid key={charger._id} item xs={6} lg={3} xl={2}>
                                <Charger charger={charger}/>
                              </Grid>
                            ))}
                        </>
                        ) : (
                          <>
                          {displayChargers?.filter((charger) => {
                            return search.toLowerCase() === '' ? charger : charger.title.toLowerCase().includes(search)
                          }).map((charger) => (
                            <Grid key={charger._id} item xs={6} lg={3} xl={2}>
                              <Charger charger={charger}/>
                            </Grid>
                          ))}
                      </>
                        )
                        }
                        <PaginationComp pageCount={pageCount} pageNumber={pageNumber} setPageNumber={setPageNumber}/>
                      </>}
                      <div>
                        {(filteredChargers.length === 0 && hitted) && 
                        <h3>
                          No chargers found for your search
                        </h3>}
                      </div>
                    </Grid>
                  </MobileContainer>
                </>
              )
            }
            </div>
      )}
    </div>
    </>
  )

  const renderTabletChargers = () => (
    <div>
    {isLoading ? (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
        <ClipLoader
          color="#93032E"
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>      
    ) 
    : error ? (<Error500></Error500>)
    :(
      <>
      <Container style={{display: 'flex', justifyContent: 'space-between'}}>
        <div style={{marginTop: '64px'}}>{user?._id &&
            <Sidebar handleFilterChargers={handleFilterChargers} resetFilter={resetFilter}/>}
        </div>
        <div id="filterContainer">
          <TextField variant="outlined" size="small" placeholder="search charger by name" onChange={(e) => setSearch(e.target.value)} value={search} id="searchInput" style={{backgroundColor: '#fff'}}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  {
                    search === "" ? (
                      <SearchIcon className="iconClass" />
                    ) : (<ClearIcon className="iconClass" onClick={clearSearch}/>)
                  }
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div>
          {user?.isAdmin &&
                (
                    <div>
                    <Button
                      id="demo-positioned-button"
                      aria-controls={open ? 'demo-positioned-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      onClick={handleClick}
                    >
                      Dashboard
                    </Button>
                    <Menu
                      id="demo-positioned-menu"
                      aria-labelledby="demo-positioned-button"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <MenuItem onClick={handleClose}>Profile</MenuItem>
                      <MenuItem onClick={handleClose}>My account</MenuItem>
                      <MenuItem onClick={handleClose}>Logout</MenuItem>
                    </Menu>
                  </div>
                )
          }
        </div>
      </Container>

        <Container>
          <Grid container justify="center" spacing={10} className="gridClass">
            {(filteredChargers?.length > 0 ) &&
            <>
              {filteredChargers.map((charger) => (
                <Grid key={charger._id} item>
                  <Charger charger={charger}/>
                </Grid>
              ))}
            </>}
            {!hitted &&
            <> 
                {displayChargers?.filter((charger) => {
                   return search.toLowerCase() === '' ? charger : charger.title.toLowerCase().includes(search)
                 }).map((charger) => (
                   <Grid key={charger._id} item>
                     <Charger charger={charger}/>
                   </Grid>
                 ))}
             </>    
            }
         
         <PaginationComp pageCount={pageCount} pageNumber={pageNumber} setPageNumber={setPageNumber}/>
          </Grid>
        </Container>
      </>
    )
  }
  </div>
  )

  const renderDesktopChargers = () => (
    <>
    <div style={{width: '1200px', margin: '0 auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
    <div>
    {user?.isAdmin &&
              (
              <div style={{display:'flex', justifyContent:'center', flexDirection:'column', alignItems:'center', marginTop:'50px'}}>
                <div>
                  <Button variant="contained" style={{width: '200px', marginBottom: '30px'}} onClick={() => navigate("/charger/create")}>Create Charger</Button>
                </div>
                <div>
                  <StackSelect/>
                </div>
              </div>
            )
    }
    </div>
    {(isLoading) ? (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
        <ClipLoader
          color="#93032E"
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>      
    ) 
    : (error) ? (<Error500></Error500>)
    :(
      <>
        <Container style={{display: 'flex', flexDirection:'column'}}>
          <div style={{marginBottom:'50px'}}>
            <h1 style={{textAlign:'center'}}>Chargers</h1>
          </div>
          <div style={{display:'flex'}}>
          <Sidebar type={"charger"} handleFilterChargers={handleFilterChargers} resetFilter={resetFilter}/>
          <Box sx={{ flexGrow: 1 }}>
          <Grid container>
              <>
              <>
                 {displayChargers?.map((charger) => (
                  <Grid key={charger._id} item>
                    <Charger charger={charger}/>
                  </Grid>
                ))}
              </>
              
              {/* <>
                {filteredChargers.map((charger) => (
                  <Grid key={charger._id} item>
                    <Charger charger={charger}/>
                  </Grid>
                ))}
              </>   */}

     
        <Container style={{width:'100%'}}>
        {pageCount !== 1 &&
          <PaginationComp 
          pageCount={pageCount} 
          paramsPage={params.page} 
          pageNumber={pageNumber} 
          setPageNumber={setPageNumber}/>
        }
        </Container>
              </>
          </Grid>
        </Box>
          </div>
        </Container>

   
      </>
    )
  }
  </div>
  </>
  )

  return (
    <div>
        {
        (isXs) ?  renderMobileChargers() : 
        (isSm) ? renderMobileChargers() :
        (isMd) ? renderTabletChargers() :
        renderDesktopChargers()
      }
    </div>
  );
};

export default Chargers;